module.exports = __webpack_public_path__ + "static/img/8.4819121.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/2/eng/8.png
// module id = GBNx
// module chunks = 0